/**
 * @generated SignedSource<<318feef827ec88876cc31c225e946549>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomePageQuery$variables = {
  url: string;
  username: string;
};
export type HomePageQuery$data = {
  readonly userProfileByUsername: {
    readonly id: string;
    readonly userReviews: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly onlyVisibleToRecipient: boolean;
        };
      }>;
    };
    readonly visitorCanEdit: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"Footer_userProfile" | "Projects_userProfile" | "Services_userProfile" | "UserProfile_userProfile" | "UserReviews_userProfile">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"IndependentPortfolioTemplates_queryFragment" | "UrlMetaData_queryFragment">;
};
export type HomePageQuery = {
  response: HomePageQuery$data;
  variables: HomePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "url"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitorCanEdit",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onlyVisibleToRecipient",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPositiveReview",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUsername",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = [
  (v3/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = [
  (v3/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "generalInquiryCtaIsVisible",
  "storageKey": null
},
v18 = [
  (v3/*: any*/),
  (v11/*: any*/)
],
v19 = [
  (v3/*: any*/),
  (v14/*: any*/)
],
v20 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Role",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v19/*: any*/),
    "storageKey": null
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "animated",
  "storageKey": null
},
v24 = {
  "kind": "Literal",
  "name": "excludeDrafts",
  "value": true
},
v25 = [
  (v24/*: any*/),
  {
    "kind": "Literal",
    "name": "type",
    "value": "PROJECT"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v23/*: any*/),
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalFormat",
          "storageKey": null
        },
        (v27/*: any*/),
        (v11/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PortfolioProjectImageCover",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    }
  ],
  "type": "PortfolioProjectTextCover",
  "abstractKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "cover",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraVideo",
          "kind": "LinkedField",
          "name": "video",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "PortfolioProjectVideoCover",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioProjectRoleConnection",
  "kind": "LinkedField",
  "name": "roles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectRoleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v20/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PortfolioProjectOrganizationConnection",
  "kind": "LinkedField",
  "name": "organizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectOrganizationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v24/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nid",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interval",
  "storageKey": null
},
v39 = [
  (v3/*: any*/),
  (v36/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developmentSlug",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "userProfileByUsername",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserReviewConnection",
            "kind": "LinkedField",
            "name": "userReviews",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserReviewEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserReview",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserProfile_userProfile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Projects_userProfile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Services_userProfile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserReviews_userProfile"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Footer_userProfile"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UrlMetaData_queryFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "IndependentPortfolioTemplates_queryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "userProfileByUsername",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserReviewConnection",
            "kind": "LinkedField",
            "name": "userReviews",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserReviewEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserReview",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentOnlyVisibleToRecipient",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reviewText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v3/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "onboardingType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContraImage",
                            "kind": "LinkedField",
                            "name": "avatarImage",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "logoImage",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserReviewAssociatedWork",
                        "kind": "LinkedField",
                        "name": "associatedWork",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaidProjectProfile",
                            "kind": "LinkedField",
                            "name": "paidProjectProfile",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProject",
                            "kind": "LinkedField",
                            "name": "portfolioProject",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedService",
                            "kind": "LinkedField",
                            "name": "productizedService",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v10/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileDisplayType",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasActivePortfolio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryJobPostingCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "topIndependentStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandCustomization",
            "kind": "LinkedField",
            "name": "brandCustomization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandCustomizationLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContraImage",
                    "kind": "LinkedField",
                    "name": "logoImage",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileRoleConnection",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserAccountRoleEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v20/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContraImage",
            "kind": "LinkedField",
            "name": "avatarImage",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v11/*: any*/),
              (v21/*: any*/),
              (v12/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "UserProfilePortfolioProjectConnection",
            "kind": "LinkedField",
            "name": "portfolioProjects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfilePortfolioProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v30/*: any*/),
                      (v3/*: any*/),
                      (v31/*: any*/),
                      (v16/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioProjectToolConnection",
                        "kind": "LinkedField",
                        "name": "tools",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProjectToolEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Tool",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "blocknoteContent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contributionYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "userProfile",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": (v34/*: any*/),
                            "concreteType": "UserProfileProductizedServiceConnection",
                            "kind": "LinkedField",
                            "name": "productizedServices",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfileProductizedServiceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductizedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "productizedServices(excludeDrafts:true)"
                          },
                          {
                            "alias": null,
                            "args": (v25/*: any*/),
                            "concreteType": "UserProfilePortfolioProjectConnection",
                            "kind": "LinkedField",
                            "name": "portfolioProjects",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfilePortfolioProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PortfolioProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "portfolioProjects(excludeDrafts:true,type:\"PROJECT\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserProfileExternalLinkConnection",
                            "kind": "LinkedField",
                            "name": "externalLinks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfileExternalLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserProfileExternalLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v35/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SocialMediaSite",
                                        "kind": "LinkedField",
                                        "name": "socialMediaSite",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserReviewConnection",
                            "kind": "LinkedField",
                            "name": "userReviews",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserReviewEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserReview",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioProjectOtherProjectConnection",
                        "kind": "LinkedField",
                        "name": "otherPortfolioProjectsByUser",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioProjectOtherProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PortfolioProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v3/*: any*/),
                                  (v31/*: any*/),
                                  (v16/*: any*/),
                                  (v30/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "portfolioProjects(excludeDrafts:true,type:\"PROJECT\")"
          },
          {
            "alias": null,
            "args": (v34/*: any*/),
            "concreteType": "UserProfileProductizedServiceConnection",
            "kind": "LinkedField",
            "name": "productizedServices",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileProductizedServiceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductizedService",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v31/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServicePortfolioProjectConnection",
                        "kind": "LinkedField",
                        "name": "portfolioProjects",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductizedServicePortfolioProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PortfolioProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v31/*: any*/),
                                  (v7/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "cover",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productizedServiceType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServiceDuration",
                        "kind": "LinkedField",
                        "name": "duration",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductizedServicePrice",
                        "kind": "LinkedField",
                        "name": "price",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v38/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeline",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "productizedServices(excludeDrafts:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileExternalLinkConnection",
            "kind": "LinkedField",
            "name": "externalLinks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileExternalLinkEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileExternalLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v35/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialMediaSite",
                        "kind": "LinkedField",
                        "name": "socialMediaSite",
                        "plural": false,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndependentPortfolioTemplateTheme",
            "kind": "LinkedField",
            "name": "independentPortfolioTemplateTheme",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IndependentPortfolioTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ThemeCustomization",
                "kind": "LinkedField",
                "name": "themeCustomization",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "accentFontPack",
                    "plural": false,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeBackgroundStyle",
                    "kind": "LinkedField",
                    "name": "backgroundStyle",
                    "plural": false,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "bodyFontPack",
                    "plural": false,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColorPrimary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fontColorSecondary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "fontPack",
                    "plural": false,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThemeFontPack",
                    "kind": "LinkedField",
                    "name": "headingFontPack",
                    "plural": false,
                    "selections": (v39/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomizationLayout",
                    "kind": "LinkedField",
                    "name": "layout",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ThemeProjectLayout",
                        "kind": "LinkedField",
                        "name": "projectsVariant",
                        "plural": false,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ThemeServiceLayout",
                        "kind": "LinkedField",
                        "name": "servicesVariant",
                        "plural": false,
                        "selections": (v39/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContraImage",
                    "kind": "LinkedField",
                    "name": "logoImage",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "url",
            "variableName": "url"
          }
        ],
        "concreteType": "UrlMetaData",
        "kind": "LinkedField",
        "name": "urlMetaData",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "twitterImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canonicalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openGraphImageAltText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlMetadataImageDimensions",
            "kind": "LinkedField",
            "name": "openGraphImageDimensions",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IndependentPortfolioTemplateConnection",
        "kind": "LinkedField",
        "name": "independentPortfolioTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IndependentPortfolioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IndependentPortfolioTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v41/*: any*/),
                  (v40/*: any*/),
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndependentPortfolioTemplateThemeConnection",
                    "kind": "LinkedField",
                    "name": "themes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndependentPortfolioTemplateThemeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IndependentPortfolioTemplateTheme",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v41/*: any*/),
                              (v40/*: any*/),
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "generatedPreviewImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "previewImage",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93ca8d7154c58babed4e750735662bed",
    "id": null,
    "metadata": {},
    "name": "HomePageQuery",
    "operationKind": "query",
    "text": "query HomePageQuery(\n  $username: String!\n  $url: String!\n) {\n  userProfileByUsername(username: $username) {\n    id\n    visitorCanEdit\n    userReviews {\n      edges {\n        node {\n          id\n          onlyVisibleToRecipient\n        }\n      }\n    }\n    ...UserProfile_userProfile\n    ...Projects_userProfile\n    ...Services_userProfile\n    ...UserReviews_userProfile\n    ...Footer_userProfile\n  }\n  ...UrlMetaData_queryFragment\n  ...IndependentPortfolioTemplates_queryFragment\n}\n\nfragment Footer_userProfile on UserProfile {\n  id\n  visitorCanEdit\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  userReviews {\n    edges {\n      node {\n        id\n        onlyVisibleToRecipient\n        isPositiveReview\n      }\n    }\n  }\n}\n\nfragment IndependentPortfolioTemplates_queryFragment on Query {\n  independentPortfolioTemplates {\n    edges {\n      node {\n        id\n        displayName\n        developmentSlug\n        isLive\n        accessLevel\n        themes {\n          edges {\n            node {\n              id\n              displayName\n              developmentSlug\n              isLive\n              generatedPreviewImage\n              previewImage {\n                id\n                uid\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OtherProjects_portfolioProjectOtherProjectConnection on PortfolioProjectOtherProjectConnection {\n  edges {\n    node {\n      analyticsId\n      id\n      slug\n      title\n      roles {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      organizations {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      cover {\n        __typename\n        ... on PortfolioProjectImageCover {\n          __typename\n          image {\n            id\n            animated\n            height\n            originalFormat\n            sizeBytes\n            uid\n            width\n          }\n        }\n        ... on PortfolioProjectTextCover {\n          __typename\n          style\n        }\n        ... on PortfolioProjectVideoCover {\n          __typename\n          video {\n            uid\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectHeader_portfolioProject on PortfolioProject {\n  id\n  title\n  contributionYear\n  organizations {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  tools {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment Project_portfolioProject on PortfolioProject {\n  analyticsId\n  id\n  slug\n  title\n  blocknoteContent\n  contributionYear\n  cover {\n    __typename\n    ... on PortfolioProjectImageCover {\n      __typename\n      image {\n        id\n        animated\n        height\n        originalFormat\n        sizeBytes\n        uid\n        width\n      }\n    }\n    ... on PortfolioProjectTextCover {\n      __typename\n      style\n    }\n    ... on PortfolioProjectVideoCover {\n      __typename\n      video {\n        uid\n        id\n      }\n    }\n  }\n  userProfile {\n    id\n    firstName\n    displayUsername\n    generalInquiryCtaIsVisible\n    productizedServices(excludeDrafts: true) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    portfolioProjects(type: PROJECT, excludeDrafts: true) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    externalLinks {\n      edges {\n        node {\n          id\n          label\n          url\n          socialMediaSite {\n            nid\n            id\n          }\n        }\n      }\n    }\n    ...Footer_userProfile\n  }\n  roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  tools {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  organizations {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  otherPortfolioProjectsByUser {\n    edges {\n      node {\n        analyticsId\n        id\n        slug\n        title\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n        }\n        roles {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        organizations {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n    ...OtherProjects_portfolioProjectOtherProjectConnection\n  }\n  ...ProjectHeader_portfolioProject\n}\n\nfragment Projects_userProfile on UserProfile {\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        analyticsId\n        id\n        slug\n        title\n        roles {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        tools {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        organizations {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n          ... on PortfolioProjectVideoCover {\n            __typename\n            video {\n              uid\n              id\n            }\n          }\n        }\n        ...Project_portfolioProject\n      }\n    }\n  }\n}\n\nfragment Services_userProfile on UserProfile {\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        analyticsId\n        id\n        slug\n        title\n        portfolioProjects {\n          edges {\n            node {\n              analyticsId\n              id\n              title\n              slug\n              cover {\n                __typename\n                ... on PortfolioProjectImageCover {\n                  __typename\n                  image {\n                    id\n                    animated\n                    height\n                    originalFormat\n                    sizeBytes\n                    uid\n                    width\n                  }\n                }\n                ... on PortfolioProjectTextCover {\n                  __typename\n                  style\n                }\n              }\n            }\n          }\n        }\n        productizedServiceType\n        duration {\n          amount\n          interval\n        }\n        price {\n          type\n          interval\n          amount\n          timeline\n        }\n      }\n    }\n  }\n}\n\nfragment UrlMetaData_queryFragment on Query {\n  urlMetaData(url: $url) {\n    title\n    description\n    facebookImageUrl\n    twitterImageUrl\n    canonicalUrl\n    openGraphImageAltText\n    updatedAt\n    openGraphImageDimensions {\n      width\n      height\n    }\n  }\n}\n\nfragment UserProfile_userProfile on UserProfile {\n  id\n  analyticsId\n  displayUsername\n  firstName\n  lastName\n  location\n  profileDisplayType\n  title\n  bio\n  visitorCanEdit\n  generalInquiryCtaIsVisible\n  hasActivePortfolio\n  primaryJobPostingCategory\n  topIndependentStatus\n  brandCustomization {\n    logo {\n      logoImage {\n        id\n        uid\n      }\n      id\n    }\n    id\n  }\n  roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  avatarImage {\n    id\n    uid\n    height\n    url\n    width\n    animated\n  }\n  portfolioProjects(type: PROJECT, excludeDrafts: true) {\n    edges {\n      node {\n        analyticsId\n        cover {\n          __typename\n          ... on PortfolioProjectImageCover {\n            __typename\n            image {\n              id\n              animated\n              height\n              originalFormat\n              sizeBytes\n              uid\n              width\n            }\n          }\n          ... on PortfolioProjectTextCover {\n            __typename\n            style\n          }\n        }\n        id\n        slug\n        title\n        roles {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        organizations {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  productizedServices(excludeDrafts: true) {\n    edges {\n      node {\n        id\n        slug\n        title\n        portfolioProjects {\n          edges {\n            node {\n              id\n              slug\n            }\n          }\n        }\n        productizedServiceType\n        duration {\n          amount\n          interval\n        }\n        price {\n          type\n          interval\n          amount\n          timeline\n        }\n      }\n    }\n  }\n  externalLinks {\n    edges {\n      node {\n        id\n        label\n        url\n        socialMediaSite {\n          id\n          nid\n        }\n      }\n    }\n  }\n  independentPortfolioTemplateTheme {\n    id\n    developmentSlug\n    displayName\n    template {\n      id\n      developmentSlug\n      displayName\n    }\n    themeCustomization {\n      id\n      accentFontPack {\n        id\n        nid\n      }\n      backgroundColor\n      backgroundStyle {\n        id\n        nid\n      }\n      bodyFontPack {\n        id\n        nid\n      }\n      fontColorPrimary\n      fontColorSecondary\n      fontPack {\n        id\n        nid\n      }\n      headingFontPack {\n        id\n        nid\n      }\n      layout {\n        projectsVariant {\n          id\n          nid\n        }\n        servicesVariant {\n          id\n          nid\n        }\n      }\n      logoImage {\n        id\n        uid\n        sizeBytes\n      }\n    }\n  }\n  userReviews {\n    count\n    edges {\n      node {\n        id\n        commentOnlyVisibleToRecipient\n        createdAt\n        onlyVisibleToRecipient\n        isPositiveReview\n        reviewText\n        author {\n          analyticsId\n          id\n          firstName\n          lastName\n          displayUsername\n          onboardingType\n          avatarImage {\n            id\n            uid\n            url\n          }\n          organization {\n            name\n            logoImage {\n              id\n              uid\n              url\n            }\n            id\n          }\n        }\n        associatedWork {\n          paidProjectProfile {\n            id\n            client {\n              id\n            }\n          }\n          portfolioProject {\n            id\n          }\n          productizedService {\n            id\n          }\n        }\n        ...UserReview_userReview\n      }\n    }\n  }\n}\n\nfragment UserReview_userReview on UserReview {\n  id\n  commentOnlyVisibleToRecipient\n  createdAt\n  onlyVisibleToRecipient\n  isPositiveReview\n  reviewText\n  author {\n    analyticsId\n    id\n    firstName\n    lastName\n    displayUsername\n    onboardingType\n    avatarImage {\n      id\n      uid\n      url\n    }\n    organization {\n      name\n      logoImage {\n        id\n        uid\n        url\n      }\n      id\n    }\n  }\n  associatedWork {\n    paidProjectProfile {\n      id\n      client {\n        id\n      }\n    }\n    portfolioProject {\n      id\n    }\n    productizedService {\n      id\n    }\n  }\n}\n\nfragment UserReviews_userProfile on UserProfile {\n  userReviews {\n    edges {\n      node {\n        id\n        commentOnlyVisibleToRecipient\n        createdAt\n        onlyVisibleToRecipient\n        isPositiveReview\n        reviewText\n        author {\n          analyticsId\n          id\n          firstName\n          lastName\n          displayUsername\n          onboardingType\n          avatarImage {\n            id\n            uid\n            url\n          }\n          organization {\n            name\n            logoImage {\n              id\n              uid\n              url\n            }\n            id\n          }\n        }\n        associatedWork {\n          paidProjectProfile {\n            id\n            client {\n              id\n            }\n          }\n          portfolioProject {\n            id\n          }\n          productizedService {\n            id\n          }\n        }\n        ...UserReview_userReview\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52eb7fa7bce27f23966e4481c9db860a";

export default node;
